import { useEffect } from 'react';
import { buildOrganizationJsonLd, defaultOriginForJsonLd } from '../../utils/organizationJsonLd';

const ATTR = 'data-social-trip-org-jsonld';

/**
 * 全ページ共通 Organization JSON-LD（1本のみ注入）
 */
export default function OrganizationJsonLd() {
  useEffect(() => {
    const origin = defaultOriginForJsonLd();
    const json = buildOrganizationJsonLd(origin);
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.setAttribute(ATTR, 'true');
    el.textContent = JSON.stringify(json).replace(/</g, '\\u003c');
    document.head.appendChild(el);
    return () => {
      document.head.querySelectorAll(`script[${ATTR}]`).forEach((n) => n.remove());
    };
  }, []);

  return null;
}
